import React from 'react'

// import { Container } from './styles';
const multiplies = {
  'mdn-Image--3-2': 2 / 3,
  'mdn-Image--1-1': 1 / 1,
  'mdn-Image--3-4': 4 / 3,
  'mdn-Image--1-2': 2 / 1
}
const config = {
  types: [],
  mainImg: '',
  modifiers: [
    'proportion-3-2',
    'proportion-1-1',
    'proportion-3-4',
    'proportion-1-2'
  ],
  states: []
}


const MIME = {
  jpg: 'image/jpeg',
  apng: 'image/apng',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jfif: 'image/jpeg',
  pjpeg: 'image/jpeg',
  pjp: 'image/jpeg',
  png: 'image/jpeg',
  svg: 'image/svg+xml',
  webp: 'image/webp'
}

export function useImage() {
  const [style, setStyle] = React.useState({ width: 'auto', height: 'auto' })

  const getImagetype = (src) => {
    const ext = src.substring(src.lastIndexOf(".") + 1)
    return MIME[ext] ?? MIME.jpeg

  }


  const resizeComponent= () =>{}

  const handleImageLoaded = (event, proportion) => {

    const width = event.target.clientWidth

    setStyle({
      width: `${width}px`,
      height: `${width * multiplies[proportion]}px`
    })

  }


  return {
    style,
    handleImageLoaded,
    getImagetype,
    resizeComponent,
    config,
    multiplies
  }
}
